function scrollTo(element, to, duration) {
  if (duration <= 0)
    return
  var difference = to - element.scrollTop
  var perTick = difference / duration * 10

  setTimeout(function() {
    element.scrollTop = element.scrollTop + perTick
    if (element.scrollTop === to)
      return
    scrollTo(element, to, duration - 10)
  }, 10)
}

function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

module.exports = {
  scrollTo: scrollTo,
  validateEmail: validateEmail
}



// WEBPACK FOOTER //
// ./src/util/util.js